import { Typography, Box } from "@mui/material";
import { breadcrumbActiveStyle, breadcrumbInactiveStyle } from "./CouponStyles";
import { LG } from "../../styles/liquidGlass";

interface BreadcrumbSectionProps {
    paymentActive?: boolean;
}

export const BreadcrumbSection: React.FC<BreadcrumbSectionProps> = ({ paymentActive }) => (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", mt: 2, mb: 1 }}>
        <Box
            sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 2,
                px: 3,
                py: 1.25,
                borderRadius: LG.radius.pill,
                background: LG.color.surfaceStrong,
                backdropFilter: LG.blurStrong,
                WebkitBackdropFilter: LG.blurStrong,
                border: `1px solid ${LG.color.borderStrong}`,
                boxShadow: LG.shadow.sm,
            }}
        >
            <Typography sx={paymentActive ? breadcrumbInactiveStyle : breadcrumbActiveStyle}>
                Entrega
            </Typography>
            <Typography sx={{ color: LG.color.textSecondary, fontSize: "0.75rem" }}>›</Typography>
            <Typography sx={paymentActive ? breadcrumbActiveStyle : breadcrumbInactiveStyle}>
                Pago
            </Typography>
        </Box>
    </Box>
);
